// redux/reducers/flashMessageReducer.js
import {
  FETCH_FLASH_REQUEST,
  FETCH_FLASH_SUCCESS,
  FETCH_FLASH_FAILURE,
  CREATE_FLASH_REQUEST,
  CREATE_FLASH_SUCCESS,
  CREATE_FLASH_FAILURE,
  UPDATE_FLASH_REQUEST,
  UPDATE_FLASH_SUCCESS,
  UPDATE_FLASH_FAILURE,
  DELETE_FLASH_REQUEST,
  DELETE_FLASH_SUCCESS,
  DELETE_FLASH_FAILURE,
} from "../actions/flashMessageActions";

const initialState = {
  flashMessages: [],
  loading: false,
  error: null,
};

export default function flashMessageReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FLASH_REQUEST:
    case CREATE_FLASH_REQUEST:
    case UPDATE_FLASH_REQUEST:
    case DELETE_FLASH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_FLASH_SUCCESS:
      return {
        ...state,
        loading: false,
        flashMessages: action.payload,
      };

    case CREATE_FLASH_SUCCESS:
    case UPDATE_FLASH_SUCCESS:
    case DELETE_FLASH_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case FETCH_FLASH_FAILURE:
    case CREATE_FLASH_FAILURE:
    case UPDATE_FLASH_FAILURE:
    case DELETE_FLASH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}